// Kredi başvuru durumları
export type CreditStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'CANCELLED' | 'EXPIRED' | 'SMS_SENT'

// Kredi başvuru kayıtı (Backend response ile eşleştirildi)
export interface CreditApplication {
  Id: number
  SerialNumber: string
  ProductCode: string
  DealerCode: string
  CompanyCode: string
  CustomerGsmNumber: string
  CreditAmount: number
  CreditAmountTL: number
  CurrencyType: string
  ExchangeRate: number
  InvoiceNumber: string
  CompayApplicationId: string // OrderId yerine
  Status: CreditStatus
  StatusDisplay: string // StatusText yerine
  ErrorMessage: string | null
  CreatedAt: string // CreatedDate yerine
  UpdatedAt: string | null // UpdatedDate yerine
  CreatedBy: string
  Document?: string // Kredi belgesi URL'si
}

// İstatistikler
export interface CreditStatistics {
  TotalCount: number
  PendingCount: number
  ApprovedCount: number
  RejectedCount: number
  CancelledCount: number
  ExpiredCount: number
  TotalAmountTL: number
  ApprovedAmountTL: number
}

// Kredi listesi filtre
export interface CreditListFilter {
  StartDate?: string
  EndDate?: string
  Status?: CreditStatus | ''
  SerialNumber?: string
  OrderId?: string
  DealerCode: string
}

// Kredi listesi yanıtı
export interface CreditListResponse {
  Items: CreditApplication[]
  TotalCount: number
  PageSize: number
  PageNumber: number
  TotalPages: number
  Statistics: CreditStatistics
}

// Status renkleri
export const StatusColors: Record<CreditStatus, string> = {
  PENDING: '#ffc107',
  APPROVED: '#28a745',
  REJECTED: '#dc3545',
  CANCELLED: '#6c757d',
  EXPIRED: '#fd7e14',
  SMS_SENT: '#17a2b8',
}

// Status Türkçe karşılıkları
export const StatusTexts: Record<CreditStatus, string> = {
  PENDING: 'Beklemede',
  APPROVED: 'Onaylandı',
  REJECTED: 'Reddedildi',
  CANCELLED: 'İptal Edildi',
  EXPIRED: 'Süresi Doldu',
  SMS_SENT: 'SMS Gönderildi',
}
